import { render, staticRenderFns } from "./ConsentListView.vue?vue&type=template&id=51ddf0e6&"
import script from "./ConsentListView.vue?vue&type=script&lang=js&"
export * from "./ConsentListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports